import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  Router
} from '@angular/router';

import {
  Subscription,
  interval
} from 'rxjs';

import Swal from 'sweetalert2';

import {
  CheckoutService,
  CheckoutData,
  CheckoutReservaResponse
} from '../../../service/checkout.service';


@Component({
  selector: 'app-checkout-pix-pagamento',
  standalone: true,

  imports: [
    CommonModule
  ],

  templateUrl: './checkout-pix-pagamento.component.html',

  styleUrl: './checkout-pix-pagamento.component.css'
})
export class CheckoutPixPagamentoComponent
  implements OnInit, OnDestroy {

  dados: CheckoutData | null = null;

  pagamento: CheckoutReservaResponse | null = null;

  carregando = true;

  private pollingSubscription?: Subscription;

  private verificandoPagamento = false;

  private finalizado = false;

  private intervaloStatus: any;

  constructor(
    private checkoutService: CheckoutService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
  }


  /* =====================================================
     INIT
  ===================================================== */

  ngOnInit(): void {

    this.iniciarMonitoramentoPagamento();

    this.dados =
      this.checkoutService.obter();

    if (
      !this.dados ||
      !this.dados.reservaId
    ) {

      this.carregando = false;

      this.cdr.detectChanges();


      Swal.fire({

        icon: 'error',

        title: 'Reserva não encontrada',

        text:
          'Não foi possível carregar os dados da reserva.',

        confirmButtonText: 'OK',

        confirmButtonColor: '#596238'

      }).then(() => {

        this.router.navigate([
          '/cabana-ype'
        ]);

      });

      return;
    }

    if (
      this.dados.pixQrCode &&
      this.dados.pixCopiaCola
    ) {

      this.pagamento = {

        reservaId:
        this.dados.reservaId,

        pagamentoId:
          this.dados.pagamentoId || 0,

        checkoutUrl:
          this.dados.checkoutUrl || null,

        pixQrCode:
          this.normalizarQrCode(
            this.dados.pixQrCode
          ),

        pixCopiaCola:
        this.dados.pixCopiaCola,

        status:
          this.dados.statusPagamento || 'PENDENTE',

        expiraEm:
          this.dados.expiraEm || null

      };


      this.carregando = false;

      this.cdr.detectChanges();

      this.iniciarPolling();

      return;
    }

    this.carregando = false;

    this.cdr.detectChanges();


    Swal.fire({

      icon: 'warning',

      title: 'PIX não encontrado',

      text:
        'O pagamento PIX ainda não foi gerado.',

      confirmButtonText: 'Voltar',

      confirmButtonColor: '#596238'

    }).then(() => {

      this.router.navigate([
        '/checkout/pix'
      ]);

    });

  }

  ngOnDestroy(): void {

    this.pararPolling();

  }

  private iniciarPolling(): void {

    this.consultarStatusPagamento();

    this.pollingSubscription =
      interval(5000)
        .subscribe(() => {

          this.consultarStatusPagamento();

        });

  }

  private iniciarMonitoramentoPagamento(): void {

    if (!this.dados?.reservaId) {
      return;
    }

    const reservaId =
      this.dados.reservaId;

    this.intervaloStatus = setInterval(() => {

      this.checkoutService
        .verificarStatusPagamento(reservaId)
        .subscribe({

          next: (resposta) => {

            if (
              resposta.status === 'PAGO' ||
              resposta.status === 'RECEIVED' ||
              resposta.status === 'CONFIRMED'
            ) {

              this.pararMonitoramento();

              this.checkoutService.atualizar({

                statusPagamento:
                resposta.status

              });

              this.router.navigate([
                '/checkout/sucesso'
              ]);

              return;
            }

            if (
              resposta.status === 'EXPIRADO' ||
              resposta.status === 'OVERDUE'
            ) {

              this.pararMonitoramento();

              this.checkoutService.atualizar({

                statusPagamento:
                  'EXPIRADO'

              });

              Swal.fire({

                icon: 'warning',

                title:
                  'PIX expirado',

                text:
                  'O prazo para pagamento terminou. Será necessário realizar uma nova reserva.',

                confirmButtonText:
                  'Fazer nova reserva',

                confirmButtonColor:
                  '#596238'

              }).then(() => {

                this.checkoutService.limpar();

                this.router.navigate([
                  '/cabana-ype'
                ]);

              });

            }

          }

        });

    }, 5000);
  }

  private pararMonitoramento(): void {

    if (this.intervaloStatus) {

      clearInterval(
        this.intervaloStatus
      );

      this.intervaloStatus = null;

    }

  }

  private pararPolling(): void {

    if (this.pollingSubscription) {

      this.pollingSubscription.unsubscribe();

      this.pollingSubscription =
        undefined;

    }

  }

  private consultarStatusPagamento(): void {

    if (
      this.verificandoPagamento ||
      this.finalizado
    ) {

      return;
    }


    if (
      !this.dados?.reservaId
    ) {

      return;
    }


    this.verificandoPagamento = true;


    const reservaId =
      this.dados.reservaId;

    this.checkoutService
      .verificarStatusPagamento(
        reservaId
      )
      .subscribe({

        next: (resposta) => {

          this.verificandoPagamento = false;

          const status =
            this.normalizarStatus(
              resposta.status
            );


          this.atualizarStatusLocal(
            status
          );

          if (
            status === 'PAGO'
          ) {

            this.pagamentoConfirmado();

            return;
          }

          if (
            status === 'EXPIRADO'
          ) {

            this.pagamentoExpirado();

            return;
          }

          if (
            status === 'CANCELADO'
          ) {

            this.pagamentoCancelado();

            return;
          }

        },


        error: (erro) => {

          this.verificandoPagamento = false;

        }

      });

  }

  private normalizarStatus(
    status: string
  ): string {

    if (!status) {

      return 'PENDENTE';

    }


    switch (
      status.toUpperCase()
      ) {

      case 'PAGO':
      case 'RECEIVED':
      case 'CONFIRMED':
        return 'PAGO';


      case 'EXPIRADO':
      case 'EXPIRED':
      case 'OVERDUE':
        return 'EXPIRADO';


      case 'CANCELADO':
      case 'CANCELED':
      case 'CANCELLED':
        return 'CANCELADO';


      case 'PENDENTE':
      case 'PENDING':
        return 'PENDENTE';


      default:
        return status.toUpperCase();

    }

  }


  private atualizarStatusLocal(
    status: string
  ): void {

    if (this.pagamento) {

      this.pagamento = {

        ...this.pagamento,

        status: status

      };

    }

    this.checkoutService.atualizar({

      statusPagamento:
      status

    });


    this.dados =
      this.checkoutService.obter();


    this.cdr.detectChanges();

  }

  private pagamentoConfirmado(): void {

    if (this.finalizado) {

      return;

    }

    this.finalizado = true;

    this.pararPolling();

    this.checkoutService.atualizar({

      statusPagamento:
        'PAGO'

    });


    Swal.fire({

      icon: 'success',

      title:
        'Pagamento confirmado!',

      text:
        'Sua reserva foi confirmada com sucesso.',

      confirmButtonText:
        'Continuar',

      confirmButtonColor:
        '#596238',

      allowOutsideClick:
        false

    }).then(() => {

      this.router.navigate([
        '/checkout/sucesso'
      ]);

    });

  }

  private pagamentoExpirado(): void {

    if (this.finalizado) {

      return;

    }


    this.finalizado = true;

    this.pararPolling();

    this.checkoutService.atualizar({

      statusPagamento:
        'EXPIRADO'

    });


    Swal.fire({

      icon: 'warning',

      title:
        'PIX expirado',

      text:
        'O prazo de pagamento terminou. A reserva foi liberada e será necessário realizar uma nova reserva.',

      confirmButtonText:
        'Fazer nova reserva',

      confirmButtonColor:
        '#596238',

      allowOutsideClick:
        false

    }).then(() => {

      this.checkoutService.limpar();


      this.router.navigate([
        '/cabana-ype'
      ]);

    });

  }


  private pagamentoCancelado(): void {

    if (this.finalizado) {

      return;

    }


    this.finalizado = true;

    this.pararPolling();


    this.checkoutService.atualizar({

      statusPagamento:
        'CANCELADO'

    });


    Swal.fire({

      icon: 'warning',

      title:
        'Pagamento cancelado',

      text:
        'O pagamento foi cancelado. Será necessário realizar uma nova reserva.',

      confirmButtonText:
        'Fazer nova reserva',

      confirmButtonColor:
        '#596238',

      allowOutsideClick:
        false

    }).then(() => {

      this.checkoutService.limpar();


      this.router.navigate([
        '/cabana-ype'
      ]);

    });

  }

  private normalizarQrCode(
    qr: string | null | undefined
  ): string {

    if (!qr) {

      return '';

    }


    let valor =
      qr.trim();


    valor =
      valor.replace(
        /^data\\:image/,
        'data:image'
      );


    if (
      !valor.startsWith('data:image')
    ) {

      valor =
        `data:image/png;base64,${valor}`;

    }


    return valor;

  }

  get qrCode(): string {

    return (
      this.pagamento?.pixQrCode ||
      ''
    );

  }

  get codigoPix(): string {

    return (
      this.pagamento?.pixCopiaCola ||
      ''
    );

  }

  get expiraEm(): string {

    return (
      this.pagamento?.expiraEm ||
      ''
    );

  }

  get valorTotal(): number {

    return (
      this.dados?.valorTotal ||
      0
    );

  }

  formatarData(
    data: string | undefined
  ): string {

    if (!data) {

      return '';

    }


    const partes =
      data.split('-');


    if (
      partes.length !== 3
    ) {

      return data;

    }


    return (
      `${partes[2]}/` +
      `${partes[1]}/` +
      `${partes[0]}`
    );

  }

  formatarExpiracao(
    data: string | null
  ): string {

    if (!data) {

      return '';

    }


    const valor =
      new Date(data);


    if (
      isNaN(valor.getTime())
    ) {

      return data;

    }


    return new Intl.DateTimeFormat(
      'pt-BR',
      {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }
    ).format(valor);

  }

  formatarStatus(
    status: string
  ): string {

    switch (status) {

      case 'PENDENTE':
      case 'PENDING':
        return 'Aguardando pagamento';


      case 'PAGO':
      case 'RECEIVED':
      case 'CONFIRMED':
        return 'Pagamento confirmado';


      case 'EXPIRADO':
      case 'EXPIRED':
      case 'OVERDUE':
        return 'PIX expirado';


      case 'REFUNDED':
        return 'Pagamento estornado';


      case 'CANCELADO':
      case 'CANCELED':
      case 'CANCELLED':
        return 'Pagamento cancelado';


      default:
        return status;

    }

  }

  copiarPix(): void {

    if (!this.codigoPix) {

      Swal.fire({

        icon: 'warning',

        title: 'PIX indisponível',

        text:
          'O código PIX ainda não foi carregado.'

      });

      return;
    }


    navigator.clipboard
      .writeText(
        this.codigoPix
      )
      .then(() => {

        Swal.fire({

          icon: 'success',

          title: 'Código copiado!',

          text:
            'O código PIX foi copiado.',

          timer: 1800,

          showConfirmButton: false

        });

      })
      .catch(() => {

        Swal.fire({

          icon: 'error',

          title:
            'Não foi possível copiar',

          text:
            'Copie o código PIX manualmente.'

        });

      });

  }

  confirmarPagamento(): void {

    this.consultarStatusPagamento();

  }

  get descricaoAcomodacao(): string {

    if (
      this.dados?.quartoId === 1
    ) {

      return 'Cabana confortável em meio à natureza';

    }


    if (
      this.dados?.quartoId === 2
    ) {

      return 'Um pedaço da Grécia em meio ao Cerrado de Goiás';

    }


    return 'Acomodação no Paraíso do Cerrado';

  }

  voltar(): void {

    this.pararPolling();


    this.router.navigate([
      '/checkout/pix'
    ]);

  }

}
